// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".admin-url .language-switch {\n  right: 135px !important;\n  top: 15rem !important;\n}\n.admin-url .language-switch h4 {\n  color: #757575 !important;\n}\n.select-content-modal .select-content {\n  position: unset;\n  margin-left: 9.5rem;\n  min-width: 19.7rem;\n  background-color: white !important;\n}\n.alert-margin {\n  margin: 1rem 3rem 1rem 1.5rem;\n}\n.content-margin-top .language-switch{\n  top: 20.3rem !important;\n}", ""]);
// Exports
module.exports = exports;
